import axios from "axios";


export default {
  login(email, password) {
    const user = { email, password };
    return axios.post(`${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}` + "/e030/login", user);
  }
};